var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconGlob(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "global-svgrepo-com",
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5597",
    "data-name": "Path 5597",
    d: "M14.451,27.683c-.074,0-.174.05-.248.05A24.834,24.834,0,0,1,3.059,16.588c0-.074.05-.174.05-.248a79.157,79.157,0,0,0,9.258,2.085A83.266,83.266,0,0,0,14.451,27.683Z",
    transform: "translate(1.569 21.611)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5598",
    "data-name": "Path 5598",
    d: "M27.83,16.613A25.052,25.052,0,0,1,16.289,27.956a75.857,75.857,0,0,0,2.259-9.531,77.639,77.639,0,0,0,9.233-2.085C27.756,16.439,27.83,16.538,27.83,16.613Z",
    transform: "translate(21.536 21.611)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5599",
    "data-name": "Path 5599",
    d: "M28.029,14.72a78.539,78.539,0,0,0-9.481-2.259A69.283,69.283,0,0,0,16.289,2.98,24.949,24.949,0,0,1,28.029,14.72Z",
    transform: "translate(21.536 1.453)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5600",
    "data-name": "Path 5600",
    d: "M14.571,3.133a77.559,77.559,0,0,0-2.06,9.233A71.654,71.654,0,0,0,2.98,14.6,25.052,25.052,0,0,1,14.323,3.059C14.4,3.059,14.5,3.133,14.571,3.133Z",
    transform: "translate(1.453 1.569)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5601",
    "data-name": "Path 5601",
    d: "M25.836,13.392a77.757,77.757,0,0,0-17.324,0A70.423,70.423,0,0,1,11.043,3.315a4.059,4.059,0,0,0,.05-.546A25.827,25.827,0,0,1,17.174,2a25.619,25.619,0,0,1,6.056.769,4.121,4.121,0,0,0,.074.546A71.263,71.263,0,0,1,25.836,13.392Z",
    transform: "translate(9.83 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5602",
    "data-name": "Path 5602",
    d: "M13.392,25.836A69.6,69.6,0,0,1,3.315,23.3a4.059,4.059,0,0,0-.546-.05A25.827,25.827,0,0,1,2,17.174a25.618,25.618,0,0,1,.769-6.056,4.121,4.121,0,0,0,.546-.074A73.89,73.89,0,0,1,13.392,8.512,80.848,80.848,0,0,0,13.392,25.836Z",
    transform: "translate(0 9.83)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5603",
    "data-name": "Path 5603",
    d: "M28.8,17.174a25.827,25.827,0,0,1-.769,6.081,4.059,4.059,0,0,0-.546.05A74.816,74.816,0,0,1,17.41,25.836a77.757,77.757,0,0,0,0-17.324,70.423,70.423,0,0,1,10.077,2.532,2.067,2.067,0,0,0,.546.074A25.784,25.784,0,0,1,28.8,17.174Z",
    transform: "translate(23.197 9.83)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5604",
    "data-name": "Path 5604",
    d: "M25.836,17.41A69.6,69.6,0,0,1,23.3,27.487a4.121,4.121,0,0,0-.074.546,25.619,25.619,0,0,1-6.056.769,25.827,25.827,0,0,1-6.081-.769,4.059,4.059,0,0,0-.05-.546A73.89,73.89,0,0,1,8.512,17.41a77.662,77.662,0,0,0,8.662.546A77.29,77.29,0,0,0,25.836,17.41Z",
    transform: "translate(9.83 23.197)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5605",
    "data-name": "Path 5605",
    d: "M27.269,27.269a74.547,74.547,0,0,1-18.681,0,74.557,74.557,0,0,1,0-18.681,74.557,74.557,0,0,1,18.681,0A74.547,74.547,0,0,1,27.269,27.269Z",
    transform: "translate(9.072 9.072)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGlob);
export default __webpack_public_path__ + "static/media/icon-glob.a10d56958484c5acea6e4e1a9b495923.svg";
export { ForwardRef as ReactComponent };